<template>
  <div>
    <!-- Date filter -->
    <div class="hist-filter">
      <button
        v-for="f in dateOptions"
        :key="f.key"
        :class="[
          'hist-chip text-muted',
          { 'hist-chip--active': dateType === f.key },
        ]"
        @click="() => (dateType = f.key)"
      >
        {{ f.label }}
      </button>
    </div>
    <div
      v-if="dateType === 'custom'"
      class="hist-custom-range mt-2"
    >
      <div class="hist-date-field">
        <!-- <label>From</label> -->
        <DateTime
          v-model="dRange"
          type="date"
          label="Date Range"
          range
          outlined
          :filled="false"
        />
        <!-- <SingleDatePicker
          v-model="dateFrom"
          label="From"
          outlined
          :max="dateTo"
        /> -->
      </div>
      <!-- <div class="hist-date-field">
        <SingleDatePicker
          v-model="dateTo"
          label="To"
          outlined
          :min="dateFrom"
        />
      </div> -->
    </div>

    <!-- Status Filter -->
    <div class="hist-filter">
      <button
        v-for="f in statusOptions"
        :key="f.key"
        :class="[
          'hist-chip text-muted',
          { 'hist-chip--active': status === f.key },
        ]"
        @click="() => (status = f.key)"
      >
        {{ f.label }}
      </button>
    </div>
    <!-- Status Filter -->
    <!-- <div class="sec-label">
      {{ historyFilterLabel }}
    </div> -->
    <div class="hist-search mb-4">
      <v-text-field
        v-model="search"
        dense
        label="Search - Vehicle No / Customer Name..."
        outlined
        clearable
        hide-details
        @keydown="fetchData"
      />
    </div>

    <!--  -->
    <Loader v-if="loading" />
    <!--  -->
    <div
      v-else-if="!filteredList.length"
      class="empty-list"
    >
      <v-icon
        color="light-gray"
        x-large
      >
        mdi-lightning-bolt-outline
      </v-icon>

      <div>No history charging sessions right now</div>
    </div>
    <!--  -->
    <div
      v-else
      class="list"
    >
      <div
        v-for="(bk, index) in filteredList"
        :key="`bk-${index}`"
        :class="[
          'bk-card',
          'bk-card--' + bk.current_status,
          {
            'bk-card--sel':
              selectedBooking &&
              (selectedBooking.booking_id
                ? selectedBooking.booking_id === bk.booking_id
                : selectedBooking?.charge_session?.session_id ===
                  bk?.charge_session?.session_id),
          },
        ]"
        @click="$emit('open-history', bk)"
      >
        <!-- <div class="stripe" /> -->
        <div class="bk-id-row d-flex justify-space-between">
          <span
            v-if="bk?.booking_id"
            class="bk-id-badge"
          >Booking No: {{ bk.booking_id }}</span>
          <span
            v-else
            class="bk-id-badge"
          >Walking Customer</span>
          <i>{{
            bk.booking_date ||
            bk?.charge_session.completed_at | formatDate("DD-MMM-YYYY")
          }}</i>
        </div>
        <div class="bk-top">
          <div>
            <div class="bk-time">
              {{
                bk.start_time_format || bk?.charge_session?.completed_at_format
              }}
              <!-- <span class="ampm"> {{ bk.ampm }}</span> -->
            </div>

            <div class="bk-sub">
              {{ bk.customer_name }} · Gun-{{ bk.connector_no | returnAlpha }}
            </div>
          </div>
          <span
            :class="['pill text-uppercase', pillClass(bk.current_status)]"
          ><span class="dot" />
            {{ bk.current_status.replace("_", " ") }}
          </span>
        </div>
        <div
          v-if="bk?.booking_id"
          class="bk-duration"
        >
          <v-icon small>
            mdi-clock-time-three-outline
          </v-icon>
          {{ bk.slot_duration_minutes }} min booking slot &nbsp;·&nbsp; Until
          {{ bk.end_time_format }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { pillClass } from "../utils/bookingHelpers";
import { debounce } from "lodash";

export default {
  name: "HistoryTab",
  components: {
    Loader: () => import("../utils/Loader.vue"),
    // SingleDatePicker: () => import("@/components/base/SingleDatePicker.vue"),
    DateTime: () => import("@/components/base/DateTime.vue"),
  },
  props: {
    selectedBooking: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      dateOptions: [
        { key: "today", label: "Today" },
        { key: "yesterday", label: "Yesterday" },
        { key: "last_03_days", label: "Last 3 Days" },
        { key: "last_07_days", label: "Last 7 Days" },
        { key: "month", label: "This Month" },
        { key: "custom", label: "Custom" },
      ],
      dateType: "today",
      dRange: [],
      // dateFrom: "",
      // dateTo: "",
      //
      status: "completed",
      statusOptions: [
        { key: "all", label: "All" },
        { key: "no_show", label: "No Show" },
        { key: "cancelled", label: "Cancelled" },
        { key: "completed", label: "Completed" },
      ],
      //
      search: "",

      //
      interval: null,
    };
  },
  computed: {
    ...mapGetters({
      loading: "bookingOperator/getLoading",
      list: "bookingOperator/getHistory",
    }),
    filteredList() {
      const st = this.status;
      if (st === "all") return this.list;
      else {
        return this.list.filter((r) => r.current_status == st);
      }
    },
    dateRange() {
      const today = new Date();

      // Format: YYYY-MM-DD
      const formatDate = (date) => {
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, "0");
        const day = String(date.getDate()).padStart(2, "0");
        return `${year}-${month}-${day}`;
      };

      switch (this.dateType) {
        case "today": {
          // const today = new Date(today);
          today.setDate(today.getDate());

          return [formatDate(today), formatDate(today)];
        }
        case "yesterday": {
          const yesterday = new Date(today);
          yesterday.setDate(today.getDate() - 1);

          return [formatDate(yesterday), formatDate(yesterday)];
        }
        case "last_03_days": {
          const start = new Date(today);
          start.setDate(today.getDate() - 2); // Today + previous 2 days

          return [formatDate(start), formatDate(today)];
        }
        case "last_07_days": {
          const start = new Date(today);
          start.setDate(today.getDate() - 6); // Today + previous 6 days

          return [formatDate(start), formatDate(today)];
        }
        case "month": {
          const start = new Date(today.getFullYear(), today.getMonth(), 1);

          return [formatDate(start), formatDate(today)];
        }

        case "custom":
          // return [this.dateFrom, this.dateTo];
          return (
            this.dRange?.map((r) => r.replace("00:00:00", "").trim()) || []
          );

        default:
          return [];
      }
    },
  },

  watch: {
    dateRange(newVal) {
      if (newVal.length > 0) {
        this.fetchData();
      }
    },
  },
  beforeDestroy() {
    if (this.interval) {
      clearTimeout(this.interval);
      this.interval = null;
    }
  },
  mounted() {
    this.fetchData();
  },
  methods: {
    pillClass,
    fetchData: debounce(async function () {
      clearTimeout(this.interval);
      this.interval = null;
      const params = {
        filter_type: "history",
        dateType: this.dateType,
        date: this.dateRange,
        search: this.search,
        abort_signal: "booking-operator-history",
      };
      await this.$store
        .dispatch(`bookingOperator/list`, params)
        .then((data) => {
          if (data.length == 0) {
            return clearTimeout(this.interval);
          }
        });
      //
      this.interval = setTimeout(() => {
        this.fetchData();
      }, 15000);
      //
    }, 300),
  },
};
</script>
<style scoped>
/* ── HISTORY FILTER ── */
.hgl-list .hist-filter {
  display: flex;
  gap: 6px;
  padding: 12px 16px 0;
  flex-wrap: wrap;
}
.hgl-list .hist-chip {
  padding: 6px 14px;
  border-radius: 20px;
  border: 1.5px solid var(--line);
  background: #fff;
  color: var(--muted);
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  font-family: inherit;
  transition: 0.15s;
}
.hgl-list .hist-chip:hover {
  border-color: var(--gradient);
  color: var(--lightGreen);
}
.hgl-list .hist-chip--active {
  background: var(--gradient);
  border-color: var(--greadient);
  color: #fff;
}
.hgl-list .hist-chip--active:hover {
  /* background: var(--lightGreen); */
  border-color: #ffff;
  color: #fff;
}
.hgl-list .hist-custom-range {
  display: flex;
  gap: 10px;
  padding: 10px 20px 0;
}
.hgl-list .hist-search {
  padding: 10px 20px 0;
}
.hgl-list .hist-date-field {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 4px;
}
.hgl-list .hist-date-field label {
  font-size: 11px;
  font-weight: 700;
  color: var(--muted);
  text-transform: uppercase;
  letter-spacing: 0.5px;
}
.hgl-list .hist-date-field input {
  padding: 8px 10px;
  border: 1.5px solid var(--line);
  border-radius: 10px;
  font-size: 13px;
  font-family: inherit;
  color: var(--darkGreen);
  background: #fff;
  outline: none;
  width: 100%;
}
.hgl-list .hist-date-field input:focus {
  border-color: var(--lightGreen);
}
</style>
